import "../styles/groups.css";
import { useInView } from "react-intersection-observer";
import Tooltip from "./tooltip";
function Groups(props) {
  const [ref, inView] = useInView({ threshold: 0 });

  return (
    <section ref={ref} className="u-clearfix u-section-3" id="Nuestros">
      <div className="data-layout-selected u-clearfix u-expanded-width u-gutter-0 u-layout-wrap u-layout-wrap-1">
        <div className="u-layout">
          <div className="u-layout-row">
            <div
              className="u-container-style u-layout-cell u-left-cell u-palette-1-base u-size-31 u-size-xs-60 u-layout-cell-1"
              src=""
            >
              <div className="u-container-layout u-valign-bottom-sm u-container-layout-1">
                <h3 className="u-align-left u-text u-text-default-lg u-text-default-md u-text-default-sm u-text-default-xl u-text-1">
                  {props.t("seccion3_1")}
                </h3>
                <h3 className="u-align-left u-text u-text-2">
                  {" "}
                  {props.t("seccion3_2")}{" "}
                </h3>
                <p className="u-align-left u-text u-text-3">
                  • {props.t("seccion3_3")}
                  <br />• {props.t("seccion3_4")}
                  <br />• {props.t("seccion3_5")}
                  <br />• {props.t("seccion3_6")}
                </p>
                <Tooltip text={props.t("tooltip_1")} position="bottom">
                  <span
                    onClick={() => props.openModal(props.t("button_1"))}
                    className="u-align-left u-border-2 u-border-grey-75 u-btn u-btn-round u-button-style u-hover-palette-1-dark-1 u-palette-2-base u-radius-50 u-btn-1"
                  >
                    {props.t("button_1")}
                  </span>
                </Tooltip>
              </div>
            </div>
            <div
              className="u-align-center u-container-style u-image u-layout-cell u-right-cell u-size-29 u-size-xs-60 u-image-1"
              src=""
              data-image-width="961"
              data-image-height="905"
            >
              <div
                className="u-container-layout u-valign-middle u-container-layout-2"
                src=""
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Groups;
